import { z } from 'zod';

export const $ValidateCompanyCreate = z.object({
  name: z.string().min(1, 'Название компании обязательно для заполнения'),
  type: z
    .string()
    .nullable()
    .refine(
      val => val !== null && val.length > 0,
      'Тип компании обязательно для заполнения'
    ),
  nif: z.string().min(1, 'NCC обязателен для заполнения'),
  city: z.string(),
  activitySpheres: z.array(z.string()).optional(),
  manager: z.string().nullable().optional(), // Валидируется вручную
  description: z
    .string()
    .min(1, 'Описание компании обязательно для заполнения'),
});

export const $ValidateCompanyUpdate = z.object({
  name: z.string().min(1, 'Название компании обязательно для заполнения'),
  type: z.string().nullable(),
  nif: z.string().min(1, 'NCC обязателен для заполнения'),
  city: z.string(),
  activitySpheres: z.array(z.string()).optional(),
  economicActivitiesIds: z.array(z.string()),
  manager: z.string().nullable().optional(), // Валидируется вручную
  description: z.string(),
});

export type ValidateCompanyCreate = z.infer<typeof $ValidateCompanyCreate>;
export type ValidateCompanyUpdate = z.infer<typeof $ValidateCompanyUpdate>;

export type CompanyCreateFormValues = {
  name: string;
  type: string | null;
  nif: string;
  city: string;
  activitySpheres?: string[];
  economicActivitiesIds?: string[];
  manager: string | null;
  description: string;
};
